import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [privileges, setPrivileges] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        try {
            const userData = JSON.parse(localStorage.getItem("vedhvidhi-admin-data") || "{}");
            let userPrivileges = [];

            if (userData && userData.role) {
                const roleData = userData.role;

                // CASE 1: Role is an object with a privileges array (New System)
                if (typeof roleData === 'object' && roleData !== null && Array.isArray(roleData.privileges)) {
                    // A wildcard '*' grants universal SUPER_ADMIN access.
                    if (roleData.privileges.includes('*')) {
                        userPrivileges = ['SUPER_ADMIN'];
                    } else {
                        // Otherwise, use the exact permissions from the array.
                        userPrivileges = roleData.privileges;
                    }
                }
                // CASE 2: Role is a simple string (Legacy System for 'admin'/'superadmin')
                else if (typeof roleData === 'string') {
                    const lowerCaseRole = roleData.toLowerCase();
                    if (lowerCaseRole === 'admin' || lowerCaseRole === 'superadmin') {
                        userPrivileges = ['SUPER_ADMIN'];
                    }
                }
            }

            setPrivileges(userPrivileges);

        } catch (error) {
            console.error("Failed to parse user data from localStorage", error);
            setPrivileges([]);
        }
        finally {
            setLoading(false);
        }
    }, []);

    const can = (permission) => {
        // This check ensures SUPER_ADMIN can access everything.
        if (privileges.includes('SUPER_ADMIN')) {
            return true;
        }
        // For regular users, check if the specific permission exists in their array.
        return privileges.includes(permission);
    };

    const value = { privileges, can, loading };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const usePermissions = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('usePermissions must be used within an AuthProvider');
    }
    return context;
};